import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

export interface ParticipantHeroPointsProps {
  /** Total tournament points to display as the hero metric. */
  value: number;
}

/**
 * Compact hero-points block rendered in `MainSection.headerRight` on the
 * participant statistics page. Big number + accent underline + "Очков" label.
 */
export const ParticipantHeroPoints: React.FC<ParticipantHeroPointsProps> = ({ value }) => {
  const { t } = useTranslation(['tournament']);
  return (
    <div className={styles.heroPoints}>
      <span className={styles.heroValue}>{value.toFixed(2)}</span>
      <span className={styles.heroUnderline} aria-hidden="true" />
      <span className={styles.heroLabel}>
        {t('tournament:participantStats.pointsLabel')}
      </span>
    </div>
  );
};

export default ParticipantHeroPoints;
